// Mercapoli - Admin Orders
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Package, Search, Loader2 } from 'lucide-react';
import { Input } from '../../components/ui/input';
import { Badge } from '../../components/ui/badge';
import { Card, CardContent } from '../../components/ui/card';
import { Tabs, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { pedidos as pedidosApi } from '../../lib/api';

const AdminOrders = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [pedidos, setPedidos] = useState([]);
  const [estadoFiltro, setEstadoFiltro] = useState('all');

  useEffect(() => {
    loadPedidos();
  }, []);

  const loadPedidos = async () => {
    try {
      const data = await pedidosApi.getAll();
      setPedidos(data);
    } catch (error) {
      console.error('Error:', error);
    }
    setLoading(false);
  };

  const getStatusColor = (status) => {
    const colors = {
      pendiente: 'bg-yellow-100 text-yellow-800',
      aceptado: 'bg-blue-100 text-blue-800',
      preparando: 'bg-purple-100 text-purple-800',
      listo: 'bg-cyan-100 text-cyan-800',
      en_camino: 'bg-orange-100 text-orange-800',
      entregado: 'bg-green-100 text-green-800',
      cancelado: 'bg-red-100 text-red-800',
    };
    return colors[status] || colors.pendiente;
  };

  const filtered = pedidos.filter(p =>
    estadoFiltro === 'all' || p.estado === estadoFiltro
  );

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-50 glass border-b border-border/50">
        <div className="container-app">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-4">
              <button onClick={() => navigate('/admin')} className="p-2 -ml-2 rounded-lg hover:bg-muted">
                <ArrowLeft className="h-5 w-5" />
              </button>
              <h1 className="font-heading text-lg font-bold">Pedidos</h1>
            </div>
            <Badge variant="outline">{pedidos.length} pedidos</Badge>
          </div>
        </div>
      </header>

      <div className="container-app py-6">
        <Tabs value={estadoFiltro} onValueChange={setEstadoFiltro} className="mb-4">
          <TabsList className="grid grid-cols-4">
            <TabsTrigger value="all">Todos</TabsTrigger>
            <TabsTrigger value="pendiente">Pend.</TabsTrigger>
            <TabsTrigger value="en_camino">En camino</TabsTrigger>
            <TabsTrigger value="entregado">Entreg.</TabsTrigger>
          </TabsList>
        </Tabs>

        {loading ? (
          <div className="flex justify-center py-12">
            <Loader2 className="h-8 w-8 animate-spin text-spicy-coral" />
          </div>
        ) : filtered.length === 0 ? (
          <div className="text-center py-12">
            <Package className="h-12 w-12 mx-auto mb-4 text-muted-foreground" />
            <p className="text-muted-foreground">No hay pedidos</p>
          </div>
        ) : (
          <div className="space-y-3">
            {filtered.map((pedido) => (
              <Card key={pedido.pedido_id}>
                <CardContent className="p-4">
                  <div className="flex items-start justify-between mb-2">
                    <div>
                      <p className="font-bold">#{pedido.pedido_id.slice(-6)}</p>
                      <p className="text-sm text-muted-foreground">
                        {new Date(pedido.created_at).toLocaleString('es-MX')}
                      </p>
                    </div>
                    <Badge className={getStatusColor(pedido.estado)}>
                      {pedido.estado.replace('_', ' ')}
                    </Badge>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-muted-foreground">
                      {pedido.items.length} productos
                    </span>
                    <span className="font-bold text-spicy-coral">
                      ${pedido.total.toFixed(2)}
                    </span>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminOrders;
